<nav *ngIf="subNav" id="subHeader" class="wab-header scrolling-wrapper">
  <div class="wab-container container-constraint" ng-reflect-klass="wab-container container-constr" ng-reflect-ng-class="[object Object]">
     <div>
        <div  class="row wab-container-row ">
           <div  class="col-lg-12 col-md-12 col-sm-12 flex-list">
              <ul  class="nav navbar-nav wab-nav wab-subnav">
                <li role="link" class="link" *ngFor="let item of subNav" (click)="selectedSubNav(item)">
                    <a *ngIf='item.selected && !item.redirect'  class="selected-link" [routerLink]="[item.link]">{{ item.name }}</a>
                    <a *ngIf='!item.selected && !item.redirect' [routerLink]="[item.link]">{{ item.name }}</a>
                    <a *ngIf='item.redirect' href= {{item.link}}>{{ item.name }}</a>
                 </li>
              </ul>
           </div>
        </div>
     </div>
  </div>
</nav>
